import {BalloonEventModel, CategoryModel} from 'ts-core';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useTranslations} from '../../contexts/Translations';
import {trackMixpanel} from '../../utils/mixpanel';

export interface CategoryCtaButtonProps {
    event: BalloonEventModel;
    category: CategoryModel;
    trackingSource?: string;
    className?: string;
}

export function CategoryCtaButton({
                                      event,
                                      category,
                                      trackingSource,
                                      className,
                                  }: CategoryCtaButtonProps) {
    const {translated, language} = useTranslations();
    const navigate = useNavigate();

    const categoryName = category.displayName.getText(language);
    const label = translated('see_more_category_events').replace('{category}', categoryName);

    const onClick = () => {
        trackMixpanel('EventDetailPage', 'CategoryCta:Click', {
            eventId: event.id,
            slug: event.slug,
            categoryId: category.id,
            categorySlug: category.slug,
            source: trackingSource,
        });
        navigate(`/categories/${category.slug}`);
    };

    return (
        <button
            onClick={onClick}
            className={
                className ??
                'inline-flex items-center gap-2 rounded-full bg-balloon text-white px-4 py-2 text-sm font-medium hover:opacity-90 transition max-w-[220px] md:max-w-none'
            }
            aria-label={label}
            title={label}
        >
            <span className="truncate">{label}</span>
        </button>
    );
}
